import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledContainer,
  StyledLoadingModal,
  StyledDescriptionText,
  StyledProgressBar,
  StyledProgress,
  StyledLoadingSpinner,
} from './styles';

export const LoadingProgressView = ({ progress, product }) => {
  const progressPercent = Math.min(progress + 0.05, 1) * 100;
  const done = `${progressPercent}%`;
  return (
    <StyledContainer>
      <StyledLoadingModal>
        <StyledLoadingSpinner />
        <StyledDescriptionText>Loading your {product}...</StyledDescriptionText>
        <StyledProgressBar>
          <StyledProgress data-testid="loading-progress-bar" $width={done} />
        </StyledProgressBar>
      </StyledLoadingModal>
    </StyledContainer>
  );
};

LoadingProgressView.displayName = 'LoadingProgressView';

LoadingProgressView.propTypes = {
  progress: PropTypes.number.isRequired,
  product: PropTypes.string.isRequired,
};
